export enum MessageKind {
  RESTRICTED_WARNING,
  NONE,
}
